module.exports = __webpack_public_path__ + "img/book.0b71f4ed.jpg";